import { Formik } from "formik"
import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import axios from "axios"
import NewTicketModal from "./NewTicketModal"
import ConfirmingAction from "common/ConfirmingAction"
import { useHistory } from "react-router-dom"

const TicketSearch = ({
  TicketSearchToggle,
  ticketSearchModal,
  setTicketData,
  newTicketToggle,
  ConfirmeNewTickettoggle,
  AddNewTicketFunction,
}) => {
  const onClose = () => {
    TicketSearchToggle()
  }

  const history = useHistory()

  const [projectNoType, setProjectNoType] = useState()
  const [projectNo, setProjectNo] = useState("")
  const [projectID, setProjectID] = useState("")
  const [projectNoError, setProjectNoError] = useState(
    "valid project no. required!"
  )
  useEffect(() => {
    const ticketData = { ProjectID: projectID }
    if (projectNoType === "ref") {
      ticketData.ReferenceNo = projectNo
      delete ticketData.RequestID
      delete ticketData.PolicyNo
    } else if (projectNoType === "request") {
      ticketData.RequestID = projectNo
      delete ticketData.ReferenceNo
      delete ticketData.PolicyNo
    } else if (projectNoType === "policy") {
      ticketData.PolicyNo = projectNo
      delete ticketData.ReferenceNo
      delete ticketData.RequestID
    }

    setTicketData(ticketData)
  }, [projectNo, projectNoType, projectID])

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ReferenceNo: projectNo,
    }

    if (projectNoType === "ref") {
      formData.ReferenceNo = projectNo
      delete formData.RequestID
      delete formData.PolicyNo
    } else if (projectNoType === "request") {
      formData.RequestID = projectNo
      delete formData.ReferenceNo
      delete formData.PolicyNo
    } else if (projectNoType === "policy") {
      formData.PolicyNo = projectNo
      delete formData.ReferenceNo
      delete formData.RequestID
    }
    axios
      .post(process.env.REACT_APP_API_URL + "api/RefCheck.php", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        if (res.data.error === true) {
          setProjectNoError("valid project no. required!")
        }

        if (res.data.error === false) {
          setProjectNoError("")

          setProjectID(res.data.ProjectID)
        }
      })
      .catch(err => console.log(err))
  }, [projectNo, projectNoType])
  // const AddNewTicketFunction = () => {
  //   newTicketToggle()
  //   TicketSearchToggle()
  // }

  // // **********confirm New Ticket Action action***************
  // const [ConfirmNewTicketModel, setConfirmNewTicketModel] = useState(false)
  // const ConfirmeNewTickettoggle = () => {
  //   setConfirmNewTicketModel(!ConfirmNewTicketModel)
  // }
  // const confirmFunc = () => {
  //   AddNewTicketFunction()
  // }

  return (
    <div>
      <Modal
        className="modal-md"
        isOpen={ticketSearchModal}
        toggle={TicketSearchToggle}
      >
        <ModalHeader>
          New Ticket
          <button
            type="button"
            className="btn-close position-absolute end-0 top-0 m-3"
            onClick={onClose}
          />
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={6}>
              <Row className="mx-1 mb-3">
                {/* ******************************* Reference No ************************************* */}
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="radioGroup"
                      value="ref"
                      onClick={e => setProjectNoType(e.target.value)}
                    />
                    Reference No
                  </Label>
                </FormGroup>

                {/* ******************************* Request No ************************************* */}
                <FormGroup check className="my-2">
                  <Label check>
                    <Input
                      type="radio"
                      name="radioGroup"
                      value="request"
                      onClick={e => setProjectNoType(e.target.value)}
                    />
                    Request No
                  </Label>
                </FormGroup>

                {/* ******************************* Policy No ************************************* */}
                <FormGroup check className="my-2">
                  <Label check>
                    <Input
                      type="radio"
                      name="radioGroup"
                      value="policy"
                      onClick={e => setProjectNoType(e.target.value)}
                    />
                    Policy No
                  </Label>
                </FormGroup>
              </Row>

              <Row>
                <FormGroup>
                  <Input
                    disabled={!projectNoType}
                    type="number"
                    name="ProjectNo"
                    value={projectNo}
                    onChange={e => {
                      setProjectNo(e.target.value)
                    }}
                  />

                  <p className="error px-1 w-100">{projectNoError}</p>
                </FormGroup>
              </Row>
            </Col>

            {/* <Col sm={6}>
              <FormGroup>
                <Label>Refrence No</Label>
                <Input
                  type="number"
                  name="ReferenceNo"
                  value={projectNo}
                  onChange={e => {
                    setProjectNo(e.target.value)
                  }}
                />

                <p className="error px-1 w-100">{projectNoError}</p>
              </FormGroup>
            </Col> */}

            <FormGroup className="d-flex ms-auto mt-3 justify-content-between">
              <Button
                onClick={() => {
                  onClose()
                }}
                className="bg-primary"
              >
                close
              </Button>

              {!projectNoError && (
                <Button
                  type="submit"
                  className="bg-primary"
                  onClick={AddNewTicketFunction}
                >
                  {"Create New Ticket"}
                </Button>
              )}
            </FormGroup>
          </Row>
        </ModalBody>
      </Modal>

      {/* *********confirm New Ticket Action action******** */}
      {/* {ConfirmNewTicketModel && (
        <ConfirmingAction
          confirmFunc={confirmFunc}
          action={"warning"}
          ConfirmeNewTickettoggle={ConfirmeNewTickettoggle}
          ConfirmNewTicketModel={ConfirmNewTicketModel}
          massege={"Are you sure that you want to add ticket and send it to the client immediately ?"}
        />
      )} */}
    </div>
  )
}

export default TicketSearch
